/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentCanceledStatusFault } from "./PaymentCanceledStatusFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_CANCELED" = "PAYMENT_CANCELED"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment and ActivatePayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to Nodo errors related to payment status conflicts.
 */

// required attributes
const PaymentCanceledStatusFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: PaymentCanceledStatusFault
});

// optional attributes
const PaymentCanceledStatusFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const PaymentCanceledStatusFaultPaymentProblemJson = t.intersection(
  [
    PaymentCanceledStatusFaultPaymentProblemJsonR,
    PaymentCanceledStatusFaultPaymentProblemJsonO
  ],
  "PaymentCanceledStatusFaultPaymentProblemJson"
);

export type PaymentCanceledStatusFaultPaymentProblemJson = t.TypeOf<
  typeof PaymentCanceledStatusFaultPaymentProblemJson
>;
